import { useState } from 'react';

interface InputVisibility {
  [inputName: string]: boolean;
}

interface PasswordVisibilityHook {
  getInputType: (inputName: string) => string;
  toggleVisibility: (inputName: string) => void;
}

export const usePasswordVisibility = (): PasswordVisibilityHook => {
  const [inputVisibility, setInputVisibility] = useState<InputVisibility>({});

  const toggleVisibility = (inputName: string): void => {
    setInputVisibility((prevVisibility) => ({
      ...prevVisibility,
      [inputName]: !prevVisibility[inputName],
    }));
  };

  const getInputType = (inputName: string): string =>
    (inputVisibility[inputName] ? 'text' : 'password');

  return {
    getInputType,
    toggleVisibility,
  };
};
